import React from 'react';
import { Alert, Button, Box, Typography } from '@mui/material';
import { Sentry } from './instrument';

/**
 * ErrorBoundary - Captura erros não tratados no React
 *
 * Integrado com GlitchTip para reportar erros automaticamente.
 * Exibe uma UI amigável quando ocorre um erro fatal.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      eventId: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // Reporta o erro ao GlitchTip
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });

    // Log no console para debug local
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error, eventId } = this.state;
    if (error) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: 3,
            backgroundColor: '#f5f5f5',
          }}
        >
          <Alert
            severity="error"
            sx={{ maxWidth: 600, width: '100%', mb: 2 }}
          >
            <Typography variant="h6" gutterBottom>
              Ocorreu um erro inesperado
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Nossa equipe foi notificada automaticamente.
              {eventId && ` (ID: ${eventId.substring(0, 8)})`}
            </Typography>
            <Box
              component="pre"
              sx={{
                mt: 2,
                p: 1,
                backgroundColor: '#fff3f3',
                borderRadius: 1,
                overflow: 'auto',
                maxHeight: 200,
                fontSize: '0.75rem',
              }}
            >
              {error.message}
            </Box>
          </Alert>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleReload}
          >
            Recarregar Página
          </Button>
        </Box>
      );
    }
    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
